import { NgModule } from "@angular/core";

import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import {DragDropModule} from '@angular/cdk/drag-drop'

@NgModule({
	declarations: [],
	exports: [MatSnackBarModule, MatDialogModule, MatButtonModule, DragDropModule],
})
export class MaterialModule {}
